import { useEffect, useState } from 'react';

function useInfiniteScroll(contentSelector) {
  const [scrollThreshold, setScrollThreshold] = useState(0.75);

  useEffect(() => {
    function handleScroll() {
      const contentPage = document.querySelector(contentSelector);
      const contentHeight = contentPage ? contentPage.scrollHeight : 0;

      const commentPanel = document.querySelector('.comment-panel-container');
      const commentPanelHeight = commentPanel ? commentPanel.scrollHeight : 0;

      if (contentHeight >= commentPanelHeight) {
        const pageContent = document.querySelector('.page-content');
        const pageContentHeight = pageContent ? pageContent.scrollHeight : 0;

        const calc = contentHeight / pageContentHeight - 0.15;
        if (calc < 1) {
          setScrollThreshold(calc);
        }
      }

      const calc = contentHeight / commentPanelHeight - 0.05;
      if (calc < 1) {
        setScrollThreshold(calc);
      }
    }

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [contentSelector]);

  return scrollThreshold;
}

export default useInfiniteScroll;
